import { render, staticRenderFns } from "./StageImage.vue?vue&type=template&id=8deab030&scoped=true&"
import script from "./StageImage.vue?vue&type=script&lang=ts&"
export * from "./StageImage.vue?vue&type=script&lang=ts&"
import style0 from "./StageImage.vue?vue&type=style&index=0&id=8deab030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deab030",
  null
  
)

export default component.exports